import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Loader, EmptyState, StatusBadge } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Undo2 } from "lucide-react";

export default function Returns() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/manufacturer/returns").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  if (!items) return <Loader />;

  async function decide(id, action) {
    try { await api.post(`/manufacturer/returns/${id}/decision`, { action }); toast.success(`Return ${action.toLowerCase()}d`); load(); }
    catch (e) { toast.error(apiError(e)); }
  }

  return (
    <div className="space-y-5">
      <h1 className="font-heading text-2xl font-semibold text-forest">Returns</h1>
      {items.length === 0 ? <EmptyState title="No return requests" hint="Retailer return requests will appear here for review." icon={Undo2} /> : (
        <div className="space-y-3">
          {items.map((r) => (
            <div key={r.id} data-testid={`return-${r.id}`} className="rounded-xl border border-border bg-card p-5">
              <div className="flex flex-wrap items-start justify-between gap-2">
                <div>
                  <p className="num text-sm font-semibold text-forest">{r.order_number}</p>
                  <p className="text-sm text-ink/70">{r.reason} · Qty {r.quantity}</p>
                  {r.description && <p className="mt-1 text-xs text-ink/50">{r.description}</p>}
                </div>
                <StatusBadge status={r.status} />
              </div>
              {r.status === "REQUESTED" && (
                <div className="mt-3 flex gap-2">
                  <Button data-testid={`return-approve-${r.id}`} size="sm" className="bg-forest text-white hover:bg-forest/90" onClick={() => decide(r.id, "APPROVE")}>Approve</Button>
                  <Button data-testid={`return-reject-${r.id}`} size="sm" variant="outline" className="border-red-300 text-red-600 hover:bg-red-50" onClick={() => decide(r.id, "REJECT")}>Reject</Button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
